import React, { Component } from 'react';
import './MenuBar.css';
import WindowType from '../enums/WindowType';
import WindowEventNames from '../window/WindowEventNames';
import Windows from '../window/Windows';
import Urls from '../urls/Urls';
import IconButtonNonReact from '../components/IconButtonNonReact';
import { faCube, faHome, faBuilding} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class MenuBarWindowEntries {
	constructor({element}){
		this._element= element;
		this._element.classList.add('window-entries');
		this._windowCreated = this._windowCreated.bind(this);
		this._windowDestroyed = this._windowDestroyed.bind(this);
		Windows.addEventListener(WindowEventNames.WINDOW_CREATED,this._windowCreated);
		Windows.addEventListener(WindowEventNames.WINDOW_DESTROYED,this._windowDestroyed);
		this._mapWindowHashToEntry = new Map();
	}
	_windowCreated({window}){
		if(this._mapWindowHashToEntry.has(window.getHash()))
			return;
		let imgUrl ;
		switch(window.getType()){
			case WindowType.PLOT_DETAILED_INFORMATION:
				imgUrl = Urls.assets+'icons/UI_Button_EnterHouse.png';
				break;
			default:
				return;
		}
		const iconButton = new IconButtonNonReact({imgUrl:imgUrl, 
			 onClick:window.toggleMinimize, className:undefined, disabled:false});
		this._element.appendChild(iconButton.element);
		this._mapWindowHashToEntry.set(window.getHash(), {
			iconButton
		});
	}
	_windowDestroyed({window}){
		const entry = this._mapWindowHashToEntry.get(window.getHash());
		if(!entry)return;
		const {iconButton}=entry;
		this._element.removeChild(iconButton.element);
		this._mapWindowHashToEntry.delete(window.getHash());
	}
	get element(){
		return this._element;
	}
}